import { Card, PageWrapper, Section } from '@shared';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  max-width: 800px;
  width: 100%;
`;

interface AuthPageWrapperProps {
  children: React.ReactNode;
  pageTitle?: string;
}

export function AuthPageWrapper({ children, pageTitle }: AuthPageWrapperProps) {
  return (
    <PageWrapper pageTitle={pageTitle}>
      <Section justifyContent="center">
        <Wrapper>
          <Card>{children}</Card>
        </Wrapper>
      </Section>
    </PageWrapper>
  );
}
